import { LOCALE } from "../../../properties/Locale";
import * as yup from "yup";

export const validateBasicInfoForm = yup.object().shape({
  firstName: yup.string().required(LOCALE.name + LOCALE.required_field),
  lastName: yup.string().required(LOCALE.lastName + LOCALE.required_field),
  email: yup
    .string()
    .required(LOCALE.email + LOCALE.required_field)
    .email(LOCALE.invalid_email_address_format),
  municipality: yup
    .object()
    .nullable()
    .required(LOCALE.municipality + LOCALE.required_field),
  school: yup.object().required(LOCALE.school + LOCALE.required_field),

  // 👇 subjectType is only required if userType = "TEACHER"
  subjectType: yup.string().when("userType", {
    is: "TEACHER",
    then: (schema) =>
      schema.required(LOCALE.subjects_type + LOCALE.required_field),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),

  teachingLanguage: yup
    .string()
    .required(LOCALE.teaching_languages + LOCALE.required_field),
  yearsWorkingExperience: yup
    .string()
    .required(LOCALE.years_working_experience + LOCALE.required_field),
  workingExperienceAttachment: yup
    .array()
    .required(LOCALE.proof + LOCALE.required_field),
});
